import type { SILogReport } from '../models/report';
import { usePeriodReport } from './logYard/period/periodReport';
import { useStatusReport } from './logYard/status/statusReport';

export function listInstalledReports(): SILogReport[] {
  const statusReport = useStatusReport();
  const periodReport = usePeriodReport();

  return [statusReport, periodReport];
}
